// it-IT formatting helpers
const eur = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
const eur2 = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const num0 = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 });
const num2 = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatCurrency(v, decimals = 0) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return decimals === 2 ? eur2.format(v) : eur.format(v);
}

export function formatNumber(v, decimals = 0) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return new Intl.NumberFormat('it-IT', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(v);
}

// value expected as fraction (0..1). If already percent pass isFraction=false
export function formatPercent(v, decimals = 1, isFraction = true) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  const val = isFraction ? v * 100 : v;
  return new Intl.NumberFormat('it-IT', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(val) + '%';
}

export function formatEurPerWp(v) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return num2.format(v) + ' €/Wp';
}

// Vendita giornaliera: valore annuo / giorni totali anno
export function formatEurPerDay(v) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return eur.format(v) + '/gg';
}

export function formatKwp(v) {
  if (v === null || v === undefined || isNaN(v)) return '—';
  return num0.format(v) + ' kWp';
}

// Delta color semantics: for revenues/margins higher is good; for costs higher is bad.
// kind: 'revenue' | 'cost' | 'margin'
export function deltaClass(deltaEur, kind = 'revenue') {
  if (deltaEur === null || deltaEur === undefined || deltaEur === 0) return 'delta-neutral';
  const positive = deltaEur > 0;
  if (kind === 'cost') return positive ? 'delta-bad' : 'delta-good';
  return positive ? 'delta-good' : 'delta-bad';
}

export function isFavorable(deltaEur, kind = 'revenue') {
  if (!deltaEur) return null;
  const positive = deltaEur > 0;
  if (kind === 'cost') return !positive;
  return positive;
}
